<app-page-shell variant="wizard" [stickyChrome]="true" [withOps]="true">
  <div pageChrome>
    <app-status-bar [loading]="saveCampaignLoading" [step]="step" [skipLanding]="campaign?.landing_page_status === 'skipped'" (SaveButtonClick)="validateSave(true)">
    </app-status-bar>
  </div>
<div toastContainer></div>
    <div class="app-influencer-list">
      <app-influencer-list (sendTestEmailsEmit)="sendTestEmails($event)" [selectedInfluencer]="selectedInfluencer"   [selectedSegment]="selectedSegment" [selectedInfluencerSegmentPairs]="selectedInfluencerSegmentPairs" (changeSelectedInfluencer)="changeSelectedInfluencer($event)"   (changeSelectedSegment)="changeSelectedSegment($event)" (changeSelectedInfluencerSegmentPairs)="changeSelectedInfluencerSegmentPairs($event)"></app-influencer-list>
    </div>
</app-page-shell>
<div class="operation-box">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-2">
        <div class="text-start">
          <button (click)="handleClickBack()" class="btn btn-default stopclick" type="button">
            Back
          </button>
        </div>
      </div>
      <div class="col-md-8 d-flex justify-content-center">
        <button [disabled]="saveCampaignLoading" class="mob-btn">
        <span>@if (saveCampaignLoading) {
<i class="fa fa-spinner fa-spin me-2"></i>
}
          Mobilizing {{influencerCount}} Influencers
        </span>
      </button>
      </div>
      <div class="col-md-2">
        <div class="text-end">
          <button class="btn btn-primary me-2" (click)="validateSave()" type="button">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template let-modal #influencerAdd>
  <div class="modal-body">
    <div class="overflow-hidden">
      <app-influencer-add
        [projectId]="this.id"
        [hideClass]="true" [influencerType]="selectedInfluencer" [selectedSegment]="selectedSegment" [isModal]="true" (isModelClosed)="closeInfluencer()"
        (closeModal)=" modal.close()"></app-influencer-add>
    </div>
  </div>
</ng-template>
<ng-template let-modal #influencerEdit>
  <div class="modal-body">
    <div class="overflow-hidden">
      <app-influencer-view
        [hideClass]="true" [projectId]="this.id"
        [influencerId]="editInfluencerId"
        [isModal]="true"
        (closeModal)="modal.close()">
      </app-influencer-view>
    </div>
  </div>
</ng-template>

<ng-template #logsTable let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">Error Logs</h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title"
            (click)="close();modal.dismiss('cancel')"></button>
  </div>
  <div class="modal-body">
    @if (isImportDataFilled()) {
    <div class="import-data-container mt-4">
      <div class="import-data-invalid">
        <span>Your influencers contains errors, please fix them and try to delete again.</span>
      </div>
      <app-sb-table
        [rows]="importDataRows"
        [columns]="importDataColumns"
        [options]="importDataTableOptions">
        @for (fieldName of importDataTableColumns(); track $index; let i = $index) {
        <ng-template [sbTableCell]="'col_' + i" let-row>{{row.record[fieldName]}}</ng-template>
        }
      </app-sb-table>
    </div>
    }

  </div>
  <input type="hidden" ngbAutofocus>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close();modal.close()">Close</button>
  </div>
</ng-template>


<ng-template #csvDownload let-modal >
  <div class="modal-header">
    <h4
      class="modal-title"
      id="modal-title"
    >
      Export {{ !csvDownloadComplete ? ': Your data is being exported' : ''}}
    </h4>
    <div class="d-flex justify-content-end">
      <button
        type="button"
        aria-label="Close button"
        class="btn-close"
        aria-describedby="modal-title"
        (click)="modal.close()"
      ></button>
    </div>
  </div>
  <div class="modal-body">
    <div class="text-center">
      @if (!csvDownloadComplete && exportProgress.status !== 'failed') {
      <button class="btn btn-default" type="button">
        <span class="btn-wrapper--icon spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span class="btn-wrapper--label">
      {{exportProgress.status === 'started' ?
          'Export: started' :
          exportProgress.status === 'in-progress' ?
            'Exporting: ' + exportProgress.progress + '%' + (exportProgress.remainingTimeFormatted ? ' — remains ' + exportProgress.remainingTimeFormatted : '') :
              'Export: ' + exportProgress.status}}
    </span>
      </button>
      }
      @if (exportProgress.status === 'failed') {
      <div>
        <p class="text-danger mb-3">Export failed. Please try again.</p>
        <button class="btn btn-default" type="button" (click)="exportModelRef.close()">Close</button>
      </div>
      }
      @if (csvDownloadComplete) {
      <a class="btn btn-default" type="button" (click)="downloadExportFile()">
        <span class="btn-wrapper--label">
          {{'File Link'}}
    </span>
      </a>
      }

    </div>
  </div>
</ng-template>

